
















import Vue from 'vue'
import { Emit, Prop } from 'vue-property-decorator'
import { Component } from '@niknevis/vue-modules'

@Component({
  inheritAttrs: false
})
export default class Checkbox extends Vue {
  @Prop({ default: '' }) readonly label!: string
  @Prop() value: boolean | undefined | string[]

  @Emit('input')
  updateValue() {
  }
}
